export default __webpack_public_path__ + "static/media/logo-100px.bab9fb26.png";